export default {
    id: null,
    person: null,
    acl: null,
    active: true
}
